module.exports = __webpack_public_path__ + "img/电信.17a633cd.png";